import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import styles from './bannerCarousel.scss';

const BannerCarousel = ({ children }) => {
    const wrapperRef = useRef(null);
    const maxItems = 1;
    const maxMobileWidth = '95%';

    const responsive = [{ breakpoint: 1200, settings: { slidesToShow: 1 } }];
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: maxItems,
        slidesToScroll: 1,
        responsive,
        arrows: true,
        autoplay: true,
        initialSlide: 0,
        autoplaySpeed: 4000,
    };

    return (
        <div style={{ maxWidth: maxMobileWidth }}>
            <div className={styles.bannerCarousel} ref={wrapperRef} data-testid="banners.power-perks.carousel">
                <Slider {...sliderSettings}>
                    {children}
                </Slider>
            </div>
        </div>
    );
};

export default BannerCarousel;

BannerCarousel.propTypes = {
    children: PropTypes.node,
};

BannerCarousel.defaultProps = {
    children: null,
};
